import { useEffect, useState } from 'react'

import { fetchAtAtVisitorId, visitorIdAtAt } from '@ecomm/at-at'
import { logError } from '@ecomm/error-handling'

/**
 * Polls VID value and returns it
 * NOTE: polling for cookies is not recommended and should be avoided if at all possible.
 */
export function usePollVid() {
  const [vid, setVid] = useState<string | undefined>(visitorIdAtAt())

  useEffect(() => {
    const controller = new AbortController()
    !vid && fetchAtAtVisitorId(controller.signal).then(setVid).catch(logError)

    // Cancel polling when hook unmounts
    return () => {
      controller.abort()
    }
  }, [vid])

  return vid
}
